import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../store/hooks';
import { getKybDetailsAsync } from '../store/slices/kyb/getKybDetailsSlice';

/**
 * Reads the business' KYB details to determine how the business is registered.
 * Fetches the details once if they have not been loaded yet.
 */
export default function useBusinessRegistrationType() {
  const dispatch = useAppDispatch();
  const { value, status } = useAppSelector((state) => state.getKybDetails);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(getKybDetailsAsync());
    }
  }, [dispatch, status]);

  const isRegistered = value?.data?.businessType?.toLowerCase() === 'registered';
  const registrationType = value?.data?.registrationType?.toLowerCase();

  return {
    isRegisteredLLC: isRegistered && registrationType === 'llc',
    isBNBusiness: isRegistered && registrationType === 'bn',
    status,
  };
}
